import React, { Component } from 'react';
import { Alert, InputGroup, InputGroupAddon, InputGroupText, UncontrolledTooltip, Form, FormGroup, Label, Row, Col, Input, Button, Card, CardHeader, CardBody, CardTitle, CardText, Spinner } from 'reactstrap';
import { withRouter } from 'react-router';
import _ from 'underscore';
import { Global } from '~/App'
import API from '~/API';
import moment from 'moment';
import ModalImagen from '~/components/ModalImagen'
import ModalPorQue from '~/components/ModalPorQue'
import Turnstile from '~/components/Turnstile';
import InputCustomFieldForm from '../DetalleCuenta/InputCustomFieldForm';

import RequerimientoExito from '../components/RequerimientoExito';
import { CreaReiteracion } from '../DetalleCuenta/Requerimientos';

class IngresaRequerimiento extends Component {
    constructor(props) {
        super();
        this.state = {
            mode: 'ingreso', // 'ingreso' o 'consulta'
            step: 1,
            empresa: Global.empresaDefecto,
            servicio: "",
            documento: "",
            captchaValida: null,
            validando: false,
            servicioValido: null,
            
            // Datos personales
            nombre: "",
            apellido: "",
            rut: "",
            email: "",
            telefono: "",

            // Datos requerimiento
            tipos: [],
            tipoSeleccionado: null,
            campos: [],
            comentario: "",
            captchaFinal: null,

            // Consulta
            folioBusqueda: "",
            apellidoBusqueda: "",
            requerimientoEncontrado: null,

            cargando: false,
            mensajes: [],
            folio: null,
            requerimientosActivos: null
        }
        this.captchaValidaRef = React.createRef();
        this.captchaStep3Ref = React.createRef();
        this.onCaptchaValidaResolved = this.onCaptchaValidaResolved.bind(this);
        this.onCaptchaStep3Resolved = this.onCaptchaStep3Resolved.bind(this);
    }

    componentWillMount() {
        if (this.props.Usuario) {
            this.setState({ 
                nombre: this.props.Usuario.nombre || "",
                apellido: this.props.Usuario.apellido || "",
                rut: this.props.Usuario.rut || "",
                email: this.props.Usuario.email || "",
                telefono: this.props.Usuario.phoneNumber || ""
            });
        }
    }

    resetCaptchas() {
        if (this.captchaValidaRef.current) this.captchaValidaRef.current.reset();
        if (this.captchaStep3Ref.current) this.captchaStep3Ref.current.reset();
        this.setState({ captchaValida: null, captchaFinal: null });
    }

    resetRequerimiento() {
        this.setState({
            tipoSeleccionado: null,
            campos: [],
            comentario: "",
            captchaFinal: null
        });
        if (this.captchaStep3Ref.current) this.captchaStep3Ref.current.reset();
    }

    resetConsultaCompleta() {
        this.resetCaptchas();
        this.resetRequerimiento();
        this.setState({ step: 1, requerimientoEncontrado: null, requerimientosActivos: null });
    }

    handleReiteracionExito = (comentarioTexto) => {
        const { requerimientoEncontrado } = this.state;
        if (requerimientoEncontrado) {
            const nuevosComentarios = [
                {
                    fecha: new Date().toISOString(),
                    tipo: true, // true = Cliente
                    observacion: comentarioTexto
                },
                ...(requerimientoEncontrado.comentarios || [])
            ];
            this.setState({
                requerimientoEncontrado: {
                    ...requerimientoEncontrado,
                    token: null, // Consumimos el token. Próxima reiteración requerirá captcha.
                    comentarios: nuevosComentarios
                }
            });
        }
    }

    handleStep1Submit = (e) => {
        e.preventDefault();
        if (this.state.mode === 'ingreso') {
            this.setState({ validando: true, mensajes: [] });
        } else {
            this.setState({ cargando: true, mensajes: [] });
        }
        let sessionToken = null;
        try {
            const key = `anonToken_${this.state.empresa}_${this.state.servicio}`;
            const raw = sessionStorage.getItem(key);
            if (raw) {
                try {
                    const parsed = JSON.parse(raw);
                    if (parsed && parsed.token && parsed.ts && (Date.now() - parsed.ts < 20 * 60 * 1000)) {
                        sessionToken = parsed.token;
                    } else if (typeof parsed === 'string') {
                        sessionToken = parsed;
                    } else {
                        sessionStorage.removeItem(key);
                    }
                } catch {
                    sessionToken = raw;
                }
            }
        } catch {}

        if (sessionToken && this.state.mode === 'ingreso') {
            this.ejecutarStep1(null, sessionToken);
        } else if (this.captchaValidaRef.current) {
            this.captchaValidaRef.current.execute();
        } else {
            this.ejecutarStep1(null, null);
        }
    }

    onCaptchaValidaResolved(token) {
        if (!token) return;
        this.ejecutarStep1(token, null);
    }

    onCaptchaValidaError = () => {
        this.setState({ validando: false, cargando: false });
    };

    onCaptchaStep3Error = () => {
        this.setState({ cargando: false });
    };

    ejecutarStep1 = async (captchaToken, sessionToken) => {
        if (this.state.mode === 'ingreso') {
            this.resetRequerimiento();
            try {
                const payload = { requerimientos: true };
                if (sessionToken) payload.token = sessionToken;
                else if (captchaToken) payload.captcha = captchaToken;

                const res = await API.Call(`Consulta/${this.state.empresa}/Servicio/${this.state.servicio}`, payload);
                if (res && res.tokenSesion) {
                    try {
                        sessionStorage.setItem(`anonToken_${this.state.empresa}_${this.state.servicio}`, JSON.stringify({ token: res.tokenSesion, ts: Date.now() }));
                    } catch {}
                }
                const resData = await API.Call(`Consulta/${this.state.empresa}/Requerimientos/Campos/${this.state.servicio}`);
                if (this.captchaValidaRef.current) this.captchaValidaRef.current.reset();
                this.setState({ 
                    servicioValido: res, 
                    tiposData: resData,
                    tipos: resData.tipos,
                    step: 2, 
                    validando: false,
                    requerimientosActivos: res.RequerimientosActivos || []
                });
            } catch (error) {
                try {
                    sessionStorage.removeItem(`anonToken_${this.state.empresa}_${this.state.servicio}`);
                } catch {}
                this.resetCaptchas();
                this.setState({ validando: false, mensajes: [{ tipo: "danger", texto: error }] });
            }
        } else {
            try {
                const payload = {
                    folio: this.state.folioBusqueda,
                    apellido: this.state.apellidoBusqueda
                };
                if (captchaToken) payload.captcha = captchaToken;
                const res = await API.Call(`Consulta/${this.state.empresa}/Requerimientos/${this.state.servicio}/Consultar`, payload);
                if (this.captchaValidaRef.current) this.captchaValidaRef.current.reset();
                this.setState({ requerimientoEncontrado: res, cargando: false, step: 2 });
            } catch (error) {
                this.resetCaptchas();
                this.setState({ cargando: false, mensajes: [{ tipo: "danger", texto: error }] });
            }
        }
    }

    setCustomFieldValue = (fieldId, value) => {
        const campos = [...this.state.campos];
        const index = campos.findIndex(f => f.FieldId === fieldId);
        if (index > -1) {
            campos[index] = { ...campos[index], Value: value, OptionKey: value };
            this.setState({ campos });
        }
    }

    seleccionarTipo = async (idTipo) => {
        const tipo = this.state.tipos.find(t => t.id_tipo_evento === parseInt(idTipo));
        if (tipo) {
            const reqExistente = (this.state.requerimientosActivos || []).find(r => 
                r.tipo_evento === parseInt(idTipo)
            );

            if (reqExistente) {
                if (window.confirm("Ya existe un requerimiento activo del mismo tipo. ¿Desea agregar un nuevo comentario al requerimiento existente?")) {
                    this.setState({ cargando: true });
                    try {
                        const res = await API.Call(`Consulta/${this.state.empresa}/Requerimientos/${this.state.servicio}/Consultar`, {
                            folio: reqExistente.numero,
                            apellido: this.state.apellido,
                            token: reqExistente.token
                        });
                        this.setState({
                            mode: 'consulta',
                            step: 2,
                            requerimientoEncontrado: res,
                            cargando: false
                        });
                    } catch (e) {
                        this.setState({ cargando: false });
                        console.error("Error cargando detalles del requerimiento", e);
                    }
                    return;
                }
            }

            const { campos: allFields } = this.state.tiposData;
            const campos = tipo.fieldIds.map(id => {
                const f = allFields.find(cf => cf.FieldId === id);
                return { ...f, Value: "", OptionKey: "" };
            });
            this.setState({ 
                tipoSeleccionado: tipo, 
                campos: campos
            });
        } else {
            this.setState({ tipoSeleccionado: null, campos: [] });
        }
    }

    handleStep3Submit = (e) => {
        e.preventDefault();
        this.setState({ cargando: true, mensajes: [] });
        const necesitaCaptcha = this.state.servicio === "0";
        if (necesitaCaptcha) {
            if (this.captchaStep3Ref.current) {
                this.captchaStep3Ref.current.execute();
            }
        } else {
            this.ejecutarSubmitStep3(null);
        }
    }

    onCaptchaStep3Resolved(token) {
        if (!token) return;
        this.ejecutarSubmitStep3(token);
    }

    ejecutarSubmitStep3 = async (captchaToken) => {
        const data = {
            Nombre: this.state.nombre,
            Apellido: this.state.apellido,
            Rut: this.state.rut,
            Email: this.state.email,
            Telefono: this.state.telefono,
            tipo_evento: this.state.tipoSeleccionado.id_tipo_evento,
            campos: this.state.campos,
            comentario: this.state.comentario
        };
        if (captchaToken) {
            data.captcha = captchaToken;
        }

        try {
            const response = await API.Call(`Consulta/${this.state.empresa}/Requerimientos/${this.state.servicio}/Agregar/Anonimo`, data);
            if (this.captchaStep3Ref.current) this.captchaStep3Ref.current.reset();
            this.setState({ cargando: false, step: 4, folio: response });
        } catch (error) {
            this.resetCaptchas();
            this.setState({ cargando: false, mensajes: [{ tipo: "danger", texto: error }] });
        }
    }

    renderStep1() {
        return (
            <Form onSubmit={this.handleStep1Submit}>
                <div className="intro-text text-center mb-4">
                    <div className="btn-group mb-3">
                        <Button color={this.state.mode === 'ingreso' ? 'primary' : 'outline-primary'} onClick={() => { this.resetCaptchas(); this.resetRequerimiento(); this.setState({ mode: 'ingreso', step: 1, mensajes: [] }); }}>Ingresar Nuevo</Button>
                        <Button color={this.state.mode === 'consulta' ? 'primary' : 'outline-primary'} onClick={() => { this.resetCaptchas(); this.resetRequerimiento(); this.setState({ mode: 'consulta', step: 1, mensajes: [] }); }}>Consultar Estado</Button>
                    </div>
                    <CardTitle tag="h5">{this.state.mode === 'ingreso' ? 'Paso 1: Identifique su cuenta' : 'Consulte el estado de su requerimiento'}</CardTitle>
                    <CardText>{this.state.mode === 'ingreso' ? 'Ingrese los datos para validar su servicio.' : 'Ingrese los datos para buscar su caso.'}</CardText>
                </div>
                {Global.empresas.length > 1 &&
                    <FormGroup>
                        <Label for="empresa">Empresa</Label>
                        <Input id="empresa" type="select" value={this.state.empresa} onChange={e => this.setState({ empresa: e.target.value })}>
                            {Global.empresas.map(e => <option value={e.key} key={e.key}>{e.nombre}</option>)}
                        </Input>
                    </FormGroup>
                }
                <FormGroup>
                    <Label for="servicio" className="numero-cuenta">Número de Cuenta <ModalPorQue /></Label>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend"><InputGroupText>👤</InputGroupText></InputGroupAddon>
                        <Input value={this.state.servicio} onChange={e => this.setState({ servicio: e.target.value, captchaValida: e.target.value ? this.state.captchaValida : null })} type="number" name="servicio" id="Servicio" placeholder="Ej: 1234567" className="text-right" />
                        <InputGroupAddon id="asyntecPortalDVServicio" addonType="append">
                            <Button color="link" disabled>{this.state.servicio ? <div> - {Global.DV(this.state.servicio)}</div> : <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>}</Button>
                            <UncontrolledTooltip placement="top" target="asyntecPortalDVServicio">Dígito Verificador</UncontrolledTooltip>
                        </InputGroupAddon>
                    </InputGroup>
                </FormGroup>

                {this.state.mode === 'consulta' && (
                    <>
                        <FormGroup>
                            <Label for="folio">Número de Folio / Atención</Label>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend"><InputGroupText>#</InputGroupText></InputGroupAddon>
                                <Input value={this.state.folioBusqueda} onChange={e => this.setState({ folioBusqueda: e.target.value })} type="text" id="folio" placeholder="Ej: 1-12345" required />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <Label for="apellidoBusqueda">Primer Apellido del Solicitante</Label>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend"><InputGroupText><i className="fa fa-user" /></InputGroupText></InputGroupAddon>
                                <Input value={this.state.apellidoBusqueda} onChange={e => this.setState({ apellidoBusqueda: e.target.value })} type="text" id="apellidoBusqueda" placeholder="Ingrese el apellido registrado" required />
                            </InputGroup>
                        </FormGroup>
                    </>
                )}

                <Turnstile
                    ref={this.captchaValidaRef}
                    size="invisible"
                    sitekey={Global.apiKeyCaptcha}
                    onChange={this.onCaptchaValidaResolved}
                    onErrored={this.onCaptchaValidaError}
                    onExpired={this.onCaptchaValidaError}
                />

                <Button block size="lg" color="primary" className="mb-2" disabled={!this.state.servicio || this.state.validando || this.state.cargando || (this.state.mode === 'consulta' && (!this.state.folioBusqueda || !this.state.apellidoBusqueda))}>
                    {this.state.validando || this.state.cargando ? 'Buscando...' : this.state.mode === 'consulta' ? 'Consultar' : 'Siguiente'}
                </Button>

                <Button block color="link" type="button" onClick={async () => {
                    this.setState({ validando: true });
                    try {
                        const resData = await API.Call(`Consulta/${this.state.empresa}/Requerimientos/Campos/0`);
                        this.setState({ 
                            servicioValido: { dir_instal: "Sin Servicio", comuna_instal: "" }, 
                            tiposData: resData,
                            tipos: resData.tipos,
                            step: 2, 
                            validando: false,
                            servicio: "0"
                        });
                    } catch (e) {
                        this.setState({ validando: false, mensajes: [{ tipo: "danger", texto: "Error al cargar tipos de requerimientos" }] });
                    }
                }}>
                    Omitir número de cuenta (Requerimientos Generales)
                </Button>
            </Form>
        );
    }

    renderStep2() {
        if (this.state.mode === 'consulta') return this.renderConsultaResultado();
        return (
            <Form onSubmit={(e) => { e.preventDefault(); this.setState({ step: 3 }) }}>
                <div className="intro-text">
                    <CardTitle tag="h5">Paso 2: Sus Datos de Contacto</CardTitle>
                    <CardText>Dirección validada: <strong>{this.state.servicioValido.dir_instal}, {this.state.servicioValido.comuna_instal}</strong></CardText>
                </div>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="nombre">Nombre</Label>
                            <Input value={this.state.nombre} onChange={e => this.setState({ nombre: e.target.value })} type="text" id="nombre" required />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="apellido">Apellido</Label>
                            <Input value={this.state.apellido} onChange={e => this.setState({ apellido: e.target.value })} type="text" id="apellido" required />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup>
                    <Label for="rut">RUT</Label>
                    <Input value={this.state.rut} onChange={e => this.setState({ rut: e.target.value })} type="text" id="rut" placeholder="Ej: 12345678-9" required 
                        invalid={this.state.rut !== "" && !Global.ValidaRUT(this.state.rut)} />
                </FormGroup>
                <FormGroup>
                    <Label for="email">Correo Electrónico</Label>
                    <Input value={this.state.email} onChange={e => this.setState({ email: e.target.value })} type="email" id="email" placeholder="correo@ejemplo.com" required 
                        invalid={this.state.email !== "" && !Global.ValidateEmail(this.state.email)} />
                </FormGroup>
                <FormGroup>
                    <Label for="telefono">Teléfono de Contacto</Label>
                    <Input value={this.state.telefono} onChange={e => this.setState({ telefono: e.target.value })} type="text" id="telefono" placeholder="Ej: +56912345678" required />
                </FormGroup>
                <Row>
                    <Col xs={6}>
                        <Button block color="secondary" onClick={() => this.resetConsultaCompleta()}>Atrás</Button>
                    </Col>
                    <Col xs={6}>
                        <Button block color="primary" disabled={!this.state.nombre || !this.state.apellido || !Global.ValidaRUT(this.state.rut) || !Global.ValidateEmail(this.state.email) || !this.state.telefono}>Siguiente</Button>
                    </Col>
                </Row>
            </Form>
        );
    }

    renderConsultaResultado() {
        const { requerimientoEncontrado } = this.state;
        if (!requerimientoEncontrado) return null;
        const empresaConfig = Global.empresas.find(e => e.key === this.state.empresa);
        const habilitadoReiteracion = empresaConfig?.otros?.Reiteracion || (empresaConfig?.otros?.Requerimientos && empresaConfig?.otros?.Requerimientos?.Reiteracion);

        return (
            <div className="consulta-resultado">
                <div className="intro-text mb-4">
                    <CardTitle tag="h5">Información de su Requerimiento</CardTitle>
                    <CardText>Folio: <strong>{requerimientoEncontrado.numero}</strong></CardText>
                </div>
                <Alert color={requerimientoEncontrado.estado === 'Cerrado' ? 'success' : 'warning'} className="text-center">
                    <h4 className="alert-heading">Estado: {requerimientoEncontrado.estado}</h4>
                </Alert>
                <Card className="mb-3">
                    <CardBody>
                        <p><strong>Categoría:</strong> {requerimientoEncontrado.categoria}</p>
                        <p><strong>Clasificación:</strong> {requerimientoEncontrado.clasificacion}</p>
                        <p><strong>Subclasificación:</strong> {requerimientoEncontrado.subclasificacion}</p>
                        <p><strong>Fecha de Creación:</strong> {moment(requerimientoEncontrado.creacion).format("DD/MM/YYYY HH:mm")}</p>
                        <p><strong>Fecha Estimada Solución:</strong> {requerimientoEncontrado.estimado_solucion ? moment(requerimientoEncontrado.estimado_solucion).format("DD/MM/YYYY") : 'Pendiente'}</p>
                        {requerimientoEncontrado.solucion && <p><strong>Fecha de Solución:</strong> {moment(requerimientoEncontrado.solucion).format("DD/MM/YYYY HH:mm")}</p>}
                    </CardBody>
                </Card>
                
                {habilitadoReiteracion && (requerimientoEncontrado.cerrado === false || requerimientoEncontrado.estado === 'Abierto') && (
                    <div className="mb-4">
                        <CreaReiteracion 
                            evento={{
                                id_evento: requerimientoEncontrado.id_evento,
                                tipo_evento: requerimientoEncontrado.tipo_evento,
                                cerrado: requerimientoEncontrado.cerrado || false,
                                numero: requerimientoEncontrado.numero
                            }}
                            Servicio={{
                                empresa: this.state.empresa,
                                idServicio: this.state.servicio
                            }}
                            anonimo
                            token={requerimientoEncontrado.token}
                            onExito={this.handleReiteracionExito}
                        />
                    </div>
                )}

                {requerimientoEncontrado.comentarios && requerimientoEncontrado.comentarios.length > 0 && (
                    <div className="mb-4">
                        <h6>Historial de Comentarios:</h6>
                        {requerimientoEncontrado.comentarios.map((c, i) => (
                            <Card key={i} className="mb-2 bg-light">
                                <CardBody className="py-2 px-3">
                                    <small className="text-muted">{moment(c.fecha).format("DD/MM/YYYY HH:mm")} - {c.tipo ? 'Cliente' : 'Empresa'}</small>
                                    <p className="mb-0">{c.observacion}</p>
                                </CardBody>
                            </Card>
                        ))}
                    </div>
                )}

                <Button block color="secondary" onClick={() => this.setState({ step: 1, requerimientoEncontrado: null })}>Volver a Consultar</Button>
            </div>
        );
    }

    renderStep3() {
        const { tipoSeleccionado, campos, comentario, cargando, servicio } = this.state;
        const necesitaCaptcha = servicio === "0";
        const formInvalido = !tipoSeleccionado || !comentario || campos.some(c => c.Mandatory && !c.Value);

        return (
            <Form onSubmit={this.handleStep3Submit}>
                <div className="intro-text">
                    <CardTitle tag="h5">Paso 3: Detalle de su Requerimiento</CardTitle>
                </div>
                <FormGroup>
                    <Label for="tipo">Tipo de Requerimiento</Label>
                    <Input type="select" id="tipo" value={this.state.tipoSeleccionado?.id_tipo_evento || ""} onChange={e => this.seleccionarTipo(e.target.value)}>
                        <option value="">Seleccione una opción...</option>
                        {this.state.tipos.filter(t => this.state.servicio === "0" ? t.b_req_servicio === 0 : true).map(t => <option key={t.id_tipo_evento} value={t.id_tipo_evento}>{t.subclasificacion}</option>)}
                    </Input>
                </FormGroup>

                {tipoSeleccionado && (
                    <div className="dynamic-fields mb-3">
                        {campos.map(cf => (
                            <InputCustomFieldForm
                                key={cf.FieldId}
                                customField={cf}
                                setCustomFieldValue={(val) => this.setCustomFieldValue(cf.FieldId, val)}
                            />
                        ))}
                        <FormGroup>
                            <Label for="comentario">Descripción / Comentario *</Label>
                            <Input type="textarea" id="comentario" value={comentario} onChange={e => this.setState({ comentario: e.target.value })} rows="4" placeholder="Describa brevemente su requerimiento o reclamo..." required />
                        </FormGroup>
                    </div>
                )}

                {necesitaCaptcha && (
                    <Turnstile
                        ref={this.captchaStep3Ref}
                        size="invisible"
                        sitekey={Global.apiKeyCaptcha}
                        onChange={this.onCaptchaStep3Resolved}
                        onErrored={this.onCaptchaStep3Error}
                        onExpired={this.onCaptchaStep3Error}
                    />
                )}

                <Row>
                    <Col xs={6}>
                        <Button block color="secondary" onClick={() => { this.resetCaptchas(); this.setState({ step: 2 }); }}>Atrás</Button>
                    </Col>
                    <Col xs={6}>
                        <Button block color="primary" type="submit" disabled={formInvalido || cargando}>
                            {cargando ? 'Enviando...' : 'Enviar Requerimiento'}
                        </Button>
                    </Col>
                </Row>
            </Form>
        );
    }

    renderStep4() {
        const { folio } = this.state;
        return (
            <RequerimientoExito 
                folio={folio} 
                onVolver={() => this.props.history.push('/')} 
            />
        );
    }

    render() {
        return (
            <div className="ingresa-requerimiento">
                <Card className="panel-ingreso-requerimiento">
                    <CardHeader className="titulo-modal">Ingreso de Requerimientos y Reclamos</CardHeader>
                    <CardBody className="cuerpo-modal">
                        <Row>
                            <Col sm="12" md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }} className="bordeCompleto">
                                {this.state.step === 1 && this.renderStep1()}
                                {this.state.step === 2 && this.renderStep2()}
                                {this.state.step === 3 && this.renderStep3()}
                                {this.state.step === 4 && this.renderStep4()}

                                {this.state.mensajes.length > 0 &&
                                    <div className="mt-4">
                                        {_.map(this.state.mensajes, (m, i) => <Alert key={i} color={m.tipo} className="text-center">{m.texto}</Alert>)}
                                    </div>
                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default withRouter(IngresaRequerimiento);